import { Link } from '@wartek-id/link'
import { Text } from '@wartek-id/text-v1'

import { PANDUAN_PENGELOLAAN_URL } from 'app/KinerjaShared/utils/panduan'

import type { TListDataBlockKey } from 'app/KinerjaKSPage/components/CardDataConfirmation/utils/types'
import type { FC } from 'react'

type Props = {
  dataKey: TListDataBlockKey
  colon: React.ReactNode
  value: React.ReactNode
  valueBlock: React.ReactNode
  prefix: string
}

export const DetailCallback: FC<Props> = ({
  dataKey,
  colon,
  value,
  valueBlock,
  prefix,
}) => {
  if (
    dataKey.includes(`${prefix}NULL`) ||
    dataKey.includes(`${prefix}REJECTED`)
  )
    return (
      <div className="flex gap-4 items-center">
        {colon}
        <div className="flex items-center gap-2">
          {value}
          <Text>
            <Link
              className="!px-0"
              href={PANDUAN_PENGELOLAAN_URL}
              target="_blank"
              rel="noopener"
            >
              Cek panduan
            </Link>
            .
          </Text>
        </div>
      </div>
    )

  return <>{valueBlock}</>
}
